import React from "react";
import Pagetrans from "./pagetrans";

const Pagenotfound = () => {
  return (
    <main className="pagenotfound py-lg-5 titled-section">
      <Pagetrans className="container py-lg-3 py-xl-5">
        <h1 className="section-title text-uppercase text-center col-md-12 mx-auto">
          not found <span className="bg decorate d-none d-md-block">404</span>
        </h1>
        <div
          className="content d-flex align-items-center"
          style={{ flexFlow: "column nowrap" }}
        >
          <p className="logo-text text-center text-lg-left">
            4<span>0</span>4
          </p>
          <p className="col-lg-6 text-center">
            It appears you have reached an undefined route. You can know more
            about me from the <a href="/about">about</a> page, see my work in
            the <a href="/portfolio">portfolio</a> page and contact me through
            the <a href="/contact">contact</a> page.
          </p>
        </div>
      </Pagetrans>
    </main>
  );
};

export default Pagenotfound;
